var _classCallCheck = require("/Users/ryzentosh/Desktop/cueconcept/projects/Cuenect/02_dev/web-next/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryzentosh/Desktop/cueconcept/projects/Cuenect/02_dev/web-next/node_modules/@babel/runtime/helpers/createClass");

module.exports = /*#__PURE__*/function () {
  "use strict";

  function SDKDebug(localServerAddress) {
    var _this = this;

    _classCallCheck(this, SDKDebug);

    if (!localServerAddress) {
      throw "Bad parameters";
    } // Init WS connection.


    this.ws = new WebSocket("ws://" + localServerAddress);
    this.ws.binaryType = 'arraybuffer';

    this.ws.onerror = function (event) {
      _this._wsOnError(event);
    };

    this.ws.onclose = function (event) {
      _this._wsOnClose(event);
    };

    this.ws.onmessage = function (event) {
      _this._wsOnMessage(event);
    };

    this.ws.onopen = function () {
      console.log("WS connected to: ", localServerAddress);

      if (_this.onReady) {
        _this.onReady();
      }
    };
  } ///////////////////////
  /// PRIVATE METHODS ///
  ///////////////////////


  _createClass(SDKDebug, [{
    key: "_wsOnError",
    value: function _wsOnError(event) {
      console.error("WS Error", event);
    }
  }, {
    key: "_wsOnClose",
    value: function _wsOnClose(event) {
      console.error("WS Close", event);
    }
  }, {
    key: "_wsOnMessage",
    value: function _wsOnMessage(event) {
      var msg = JSON.parse(event.data);

      if (msg.type == "furioos" && msg.task == "sdk") {
        this._onSDKMessageCallback(JSON.parse(msg.data));
      }
    }
  }, {
    key: "_wsOnSendError",
    value: function _wsOnSendError(event) {
      console.error("WS send error", event);
    } ////////////////////////
    //// PUBLIC METHODS ////
    ////////////////////////
    // Binding onload callback.
    // SDK

  }, {
    key: "onSDKMessage",
    value: function onSDKMessage(onSDKMessageCallback) {
      this._onSDKMessageCallback = onSDKMessageCallback;
    }
  }, {
    key: "sendSDKMessage",
    value: function sendSDKMessage(data) {
      if (!this.ws || this.ws.readyState != WebSocket.OPEN) {
        console.log("Cannot send message, ws connection not open");
        return; // Not loaded.
      }

      var parsedData = {
        type: "furioos",
        task: "sdk",
        data: data
      };
      this.ws.send(JSON.stringify(parsedData), this._wsOnSendError);
    }
  }]);

  return SDKDebug;
}();